import { render, staticRenderFns } from "./ErrorBox.vue?vue&type=template&id=f96a5a5a&scoped=true&"
import script from "./ErrorBox.vue?vue&type=script&lang=ts&"
export * from "./ErrorBox.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorBox.vue?vue&type=style&index=0&id=f96a5a5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96a5a5a",
  null
  
)

export default component.exports